/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detect_Shot_ChangesInputs */



/**
* | output |
* | --- |
* | "Detect Shot Changes" |
*
* @param {Detect_Shot_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const detect_shot_changes = /** @type {((inputs?: Detect_Shot_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detect_Shot_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détecter les changements de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schusswechsel erkennen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rileva i cambiamenti di tiro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение изменений в выстреле")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detectar cambios en la toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测投篮变化")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの変更を検出する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट परिवर्तनों का पता लगाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detectar mudanças de tiro")
	return /** @type {LocalizedString} */ ("Detect Shot Changes")
});